/*!
 * Copyright © 2023. Verizon Connect Ireland Limited. All rights reserved.
 */

export enum EGeoShapeType {
  GeoPoint = 1,
  GeoCircle = 2,
  GeoRectangle = 3,
  GeoPolygon = 4,
  GeoLandmark = 5,
  GeoLine = 6
}
